<template>
  <el-card>
    <template #header>
      <h4>{{title}}</h4>
    </template>

    <el-form inline size="mini">
      <el-form-item :label="$t('名称')">
        <el-input :placeholder="$t('请输入名称')" v-model="searchForm.name" clearable />
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="$refs.list.handleSearch()">{{$t('查询')}}</el-button>
        <el-button @click="$refs.list.reset()">{{$t('重置')}}</el-button>
      </el-form-item>
    </el-form>

    <div class="flex-end mb16">
      <el-button type="primary" size="mini" @click="$emit('add')">{{$t('新增')}}</el-button>
      <el-button type="danger" size="mini" @click="handleBatchDelete">{{$t('删除')}}</el-button>
    </div>

   <div style="height: 500px">
     <table-list
         :height="500"
         :search-params="searchForm"
         @query="loadList"
         :data="dataList"
         @selection-change="selection = $event"
         ref="list">
       <el-table-column type="selection" width="80" />
       <el-table-column type="index" width="80" />
       <el-table-column :label="$t('等级名称')" prop="name" />
       <el-table-column :label="$t('积分')" prop="integral" />
       <el-table-column :label="$t('描述')" show-tooltip-when-overflow prop="remark" />
       <el-table-column :label="$t('创建时间')">
         <template v-slot="{row}">
           {{row.createTime | formatDate}}
         </template>
       </el-table-column>
       <el-table-column :label="$t('操作')">
         <template v-slot="{row}">
           <div class="fb-link-flex">
             <el-link type="primary" :underline="false" @click="$emit('edit', row)">{{$t('编辑')}}</el-link>
             <el-link type="danger" :underline="false" @click="$emit('delete', row)">{{$t('删除')}}</el-link>
           </div>
         </template>
       </el-table-column>
     </table-list>
   </div>
  </el-card>
</template>

<script>
import TableList from "@/components/table-list/TableList";
import {request} from "@/config/request";
export default {
  name: "LevelList",
  components: {TableList},
  props: {
    action: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      searchForm: {},
      dataList: [],
      selection: [],
    }
  },
  methods: {
    // 刷新
    refresh(delCount = 0) {
      this.$refs.list.handleRequest(delCount)
    },

    handleBatchDelete() {
      let codes = this.selection.map(item => item.code);
      if (!codes.length) {
        this.$message.error(this.$t('请选择要删除的数据'));
        return;
      }
      this.$emit("batch-delete", codes);
    },

    async loadList(params, setTotal) {
      try {
        if(!this.action) return;
        const res = await request(this.action, params);
        for (const key in res) {
          if(Array.isArray(res[key])) {
            this.dataList = res[key];
          }
        }
        setTotal(res.pager.itemCount);
      } catch (e) {
        console.log(e);
      }
    }
  },
}
</script>

<style scoped>

</style>
